// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__CN9dr"};